/* RoadBed theme JS: menu, search, gallery, quantity, AJAX cart, sticky ATC */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var R = window.RoadBed || { routes: { cart_add_url: '/cart/add', cart_url: '/cart', cart_change_url: '/cart/change' }, strings: {} };

  function money(cents) {
    var fmt = R.money_format || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return withCommas;
    });
  }

  /* Mobile menu */
  var menu = $('#MobileMenu');
  $$('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); b.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; });
  });
  function closeMenu() { if (!menu) return; menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
  menu && $$('a', menu).forEach(function (a) { a.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  /* Announcement rotation (mobile shows one at a time) */
  var notes = $$('[data-announcement]');
  if (notes.length > 1) {
    var ni = 0;
    setInterval(function () {
      notes[ni].classList.remove('is-active');
      ni = (ni + 1) % notes.length;
      notes[ni].classList.add('is-active');
    }, 3500);
  }

  /* Search */
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var bar = $('#SearchBar'); if (!bar) return;
      var open = bar.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open);
      if (open) { var i = $('input[type=search]', bar); i && i.focus(); }
    });
  });

  /* Galleries (spotlight + product) */
  $$('[data-spotlight], [data-gallery]').forEach(function (root) {
    var main = $('[data-main] img', root);
    var thumbs = $$('[data-thumb]', root);
    if (!main || !thumbs.length) return;
    var idx = 0;
    function show(i) {
      idx = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      main.removeAttribute('srcset');
      main.src = thumbs[idx].getAttribute('data-src');
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    /* swipe on main image */
    var sx = null, sy = null, area = $('[data-main]', root);
    area.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    area.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        show(idx + (dx < 0 ? 1 : -1));
        var t = thumbs[idx]; t.scrollIntoView && t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      sx = null;
    }, { passive: true });
    var prev = $('[data-thumb-prev]', root), next = $('[data-thumb-next]', root);
    prev && prev.addEventListener('click', function () { show(idx - 1); });
    next && next.addEventListener('click', function () { show(idx + 1); });
  });

  /* Quantity steppers */
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      input.value = v;
    });
  });

  /* Variant picker */
  $$('[data-product-form]').forEach(function (form) {
    var wrap = form.closest('[data-product]') || form.parentNode;
    var json = wrap && $('[data-variants]', wrap);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var picker = $('[data-variant-picker]', form);
    if (!picker) return;
    picker.addEventListener('change', function () {
      var opts = $$('fieldset', picker).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      var btn = $('[data-add-button]', form), label = $('[data-add-label]', form);
      if (!v) { btn.disabled = true; label && (label.textContent = R.strings.sold_out || 'Unavailable'); return; }
      $('[data-variant-id]', form).value = v.id;
      btn.disabled = !v.available;
      label && (label.textContent = v.available ? R.strings.add_to_cart : R.strings.sold_out);
      var pb = $('[data-price-block]', wrap);
      if (pb) {
        $('[data-price]', pb).textContent = money(v.price);
        var c = $('[data-compare]', pb); if (c) c.style.display = v.compare_at_price > v.price ? '' : 'none';
        if (c && v.compare_at_price) c.textContent = money(v.compare_at_price);
      }
      var sp = $('[data-sticky-price]'); sp && (sp.textContent = money(v.price));
      if (v.featured_image) { var m = $('[data-main] img', wrap); if (m) { m.removeAttribute('srcset'); m.src = v.featured_image.src; } }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    });
  });

  /* Cart count */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = n; });
  }

  /* "You're saving" boxes */
  function paintSavings(box, cents) {
    if (!box) return;
    var t = box.querySelector('[data-savings-text]');
    if (cents > 0 && t) {
      var tpl = t.getAttribute('data-savings-text') || '';
      var parts = tpl.split('[amount]');
      t.textContent = '';
      parts.forEach(function (part, i) {
        if (i > 0) { var b = document.createElement('strong'); b.textContent = money(cents); t.appendChild(b); }
        t.appendChild(document.createTextNode(part));
      });
      box.hidden = false;
    } else { box.hidden = true; }
  }
  function cartSavings(cart) {
    var total = 0;
    (cart.items || []).forEach(function (it) {
      var unit = parseInt((it.properties && it.properties._compare_unit) || '0', 10) || 0;
      var lineCmp = Math.max(unit * it.quantity, it.original_line_price || 0);
      total += Math.max(0, lineCmp - it.final_line_price);
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) { total += d.total_allocated_amount || 0; });
    return total;
  }
  function onCart(cart) {
    setCount(cart.item_count);
    paintSavings(toast && $('[data-order-savings]', toast), cartSavings(cart));
  }

  /* Toast */
  var toast = $('#CartToast'), toastTimer;
  function openToast(item) {
    if (!toast) { window.location.href = R.routes.cart_url; return; }
    var box = $('[data-toast-item]', toast);
    box.innerHTML = '';
    if (item.image) { var img = document.createElement('img'); img.src = item.image; img.alt = ''; box.appendChild(img); }
    var d = document.createElement('div');
    var t = document.createElement('strong'); t.textContent = item.product_title; d.appendChild(t);
    var p = document.createElement('div'); p.className = 'muted'; p.textContent = item.quantity + ' × ' + money(item.final_price); d.appendChild(p);
    box.appendChild(d);
    toast.classList.add('is-open');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove('is-open'); }, 6000);
  }
  toast && $('[data-toast-close]', toast).addEventListener('click', function () { toast.classList.remove('is-open'); });

  /* AJAX add */
  function addToCart(form, btn) {
    if (window.RoadBedCartType === 'page') return false;
    btn && (btn.disabled = true);
    return fetch(R.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        openToast(item);
        return fetch(R.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { onCart(cart); })
      .catch(function (e) { alertInline(form, (e && (e.description || e.message)) || R.strings.error); })
      .finally(function () { btn && (btn.disabled = false); });
  }
  function alertInline(form, msg) {
    var el = form.querySelector('.form-message');
    if (!el) { el = document.createElement('p'); el.className = 'form-message'; el.style.color = '#B91C1C'; form.appendChild(el); }
    el.textContent = msg;
  }
  $$('form[data-product-form]:not([data-bundle-form])').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (window.RoadBedCartType === 'page') return;
      e.preventDefault();
      addToCart(form, form.querySelector('[data-add-button]'));
    });
  });


  /* ---------- Bundle offer ---------- */
  $$('[data-bundle]').forEach(function (root) {
    var form = $('form[data-bundle-form]', root);
    var radios = $$('input[type=radio]', root);
    var wrap = root.closest('[data-product]') || document;
    var totalEl = $('[data-bundle-total]', root);
    var btn = $('[data-add-button]', form);

    function current() { return radios.find(function (r) { return r.checked; }) || radios[0]; }
    function giftIds(r) {
      var holder = r.closest('[data-tier]').querySelector('[data-gift-ids]');
      return holder ? holder.getAttribute('data-gift-ids').split(',').filter(Boolean) : [];
    }
    function apply() {
      var r = current(); if (!r) return;
      radios.forEach(function (x) { x.closest('[data-tier]').classList.toggle('is-selected', x === r); });
      var price = parseInt(r.dataset.price, 10), regular = parseInt(r.dataset.regular, 10);
      $('[data-variant-id]', form).value = r.dataset.addId;
      $('[data-bundle-qty]', form).value = r.dataset.addQty;
      if (totalEl) totalEl.textContent = money(price);
      var ok = r.dataset.available === 'true';
      btn.disabled = !ok;
      var lbl = $('[data-add-label]', btn); if (lbl) lbl.textContent = ok ? (R.strings.add_to_cart || 'Add to cart') : (R.strings.sold_out || 'Sold out');
      var pb = $('[data-price-block]', wrap);
      if (pb) {
        var p = $('[data-price]', pb); if (p) p.textContent = money(price);
        var c = $('[data-compare]', pb), sv = $('[data-save]', pb);
        var pctStyle = pb.getAttribute('data-save-style') === 'percent';
        var unitCompare = parseInt(pb.getAttribute('data-compare-unit') || '0', 10);
        if (pctStyle && !(regular > price) && unitCompare > price) regular = unitCompare;
        if (pctStyle && c && sv) {
          if (regular > price) {
            c.textContent = money(regular); c.style.display = '';
            var st = $('[data-save-text]', sv);
            var pctText = 'Save ' + Math.round((regular - price) * 100 / regular) + '%';
            if (st) st.textContent = pctText; else sv.textContent = pctText;
            sv.style.display = '';
          } else {
            c.style.display = 'none'; sv.style.display = 'none';
          }
        } else if (regular > price) {
          if (!c) { c = document.createElement('s'); c.className = 'price--compare'; c.setAttribute('data-compare', ''); pb.appendChild(c); }
          if (!sv) { sv = document.createElement('span'); sv.className = 'save-pill'; sv.setAttribute('data-save', ''); pb.appendChild(sv); }
          c.textContent = money(regular); c.style.display = '';
          sv.textContent = 'Save ' + money(regular - price); sv.style.display = '';
        } else {
          if (c) c.style.display = 'none';
          if (sv) sv.style.display = 'none';
        }
      }
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = money(price);
      var addQty = parseInt(r.dataset.addQty, 10) || 1;
      var cmpIn = $('[data-compare-unit-input]', form);
      if (cmpIn) cmpIn.value = regular > price ? String(Math.round(regular / addQty)) : '';
      paintSavings($('[data-order-savings]', root), regular > price ? regular - price : 0);
    }
    radios.forEach(function (r) { r.addEventListener('change', apply); });
    apply();

    form.addEventListener('submit', function (e) {
      if (window.RoadBedCartType === 'page' && !giftIds(current()).length) return;
      e.preventDefault();
      var r = current();
      var main = { id: parseInt(r.dataset.addId, 10), quantity: parseInt(r.dataset.addQty, 10) };
      var reg = parseInt(r.dataset.regular, 10), pr = parseInt(r.dataset.price, 10);
      if (reg > pr) main.properties = { _compare_unit: String(Math.round(reg / main.quantity)) };
      var items = [main].concat(giftIds(r).map(function (id) { return { id: parseInt(id, 10), quantity: 1, properties: { _bundle_gift: 'Tier ' + r.value } }; }));
      btn.disabled = true;
      function post(list) {
        return fetch(R.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); });
      }
      post(items)
        .catch(function (err) { if (items.length > 1) return post([main]); throw err; })
        .then(function (res) {
          if (window.RoadBedCartType === 'page') { window.location.href = R.routes.cart_url; return; }
          var first = res.items ? res.items[0] : res;
          openToast(first);
          return fetch(R.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (x) { return x.json(); }).then(function (cart) { onCart(cart); });
        })
        .catch(function (err) { alertInline(form, (err && (err.description || err.message)) || R.strings.error); })
        .finally(function () { btn.disabled = false; });
    });
  });

  /* Sticky ATC */
  var sticky = $('[data-sticky-atc]');
  var mainForm = $('#ProductForm');
  if (sticky && mainForm) {
    var target = $('[data-add-button]', mainForm);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
    });
    io.observe(target);
    $('[data-sticky-add]', sticky).addEventListener('click', function () {
      if (mainForm.requestSubmit) mainForm.requestSubmit(); else mainForm.submit();
    });
  }

  /* Cart page quantity */
  $$('[data-cart-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-delta'), 10));
      input.value = q;
      fetch(R.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-cart-qty'), quantity: q }) })
        .then(function () { window.location.reload(); });
    });
  });
})();
